import { Switch, Route } from 'react-router-dom';

import { useFeature } from 'FeatureProvider';

import Roles from 'containers/Roles/Loadable';
import Role from 'containers/Role/Loadable';
import Employees from 'containers/Employees/Loadable';
import EmployeesDetails from 'containers/EmployeesDetails/Loadable';

import NotFound from 'components/NotFound';

import useUserStore from 'hooks/useUserStore';
import useOrganization from 'hooks/Organization/useOrganization';

import { LicenseGuard } from 'domains/subscription';
import RolesV2 from '@users/presentation/pages/Roles/Loadable';
import RoleV2 from '@users/presentation/pages/Role/Loadable';
import EmployeesV2 from '@users/presentation/pages/Employees/Loadable';
import EmployeesDetailsV2 from '@users/presentation/pages/EmployeesDetails/Loadable';

import { useUser } from '@users/presentation/hooks/Users/hooks';
import { hasPermission } from '@users/presentation/utils/permissions';
import { ORGANIZATION_PERMISSIONS } from '@users/domain/value-objects/permissions';

import { NoPermissions } from '@users/presentation/pages/NoPermissions';

import AppRoute from '../PrivateRoute';

export function WorkforceRoutes() {
  const {
    storeState: { selected: storeSelected },
  } = useUserStore();
  const {
    organization: { newPermissionsSystem },
  } = useOrganization();
  const superUserAccess = useFeature('adminStore');
  const workforceModuleAccess = useFeature('backofficeModuleWorkforce');
  const storeAdminAccess = useFeature('storeAdmin');
  const { data: currentUser } = useUser();
  const hasUsersDisplayPermission = hasPermission(
    currentUser?.permissions,
    ORGANIZATION_PERMISSIONS.DISPLAY_USERS_AND_ROLES,
  );
  const permissionWorkforceModule =
    (superUserAccess || workforceModuleAccess || storeAdminAccess) && !storeSelected?.isDraft;

  // Si no tiene permisos de organización, mostrar el placeholder para todas las rutas
  if (newPermissionsSystem && !hasUsersDisplayPermission) {
    return (
      <Switch>
        <AppRoute accessRoute={permissionWorkforceModule} component={NoPermissions} path="/workforce/(roles|people)" />
        <Route component={NotFound} />
      </Switch>
    );
  }

  // Rutas normales para usuarios con permisos de organización
  return (
    <LicenseGuard>
      <Switch>
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={newPermissionsSystem ? RolesV2 : Roles}
          exact
          path="/workforce/roles/(create)?"
        />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={newPermissionsSystem ? RoleV2 : Role}
          exact
          path="/workforce/roles/details/:roleUuid/edit"
        />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={newPermissionsSystem ? EmployeesV2 : Employees}
          exact
          path="/workforce/people/:actionType(create)?"
        />
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={newPermissionsSystem ? EmployeesDetailsV2 : EmployeesDetails}
          exact
          path="/workforce/people/details/:employeeUuid/:actionType(duplicate|change-password)?/(edit)?"
        />
        <Route component={NotFound} />
      </Switch>
    </LicenseGuard>
  );
}
